module.exports = __webpack_public_path__ + "static/media/exit-ic-black.d0b11f88.svg";